import * as actionType from '../actions/actionTypes';
import { updateObject } from '../../components/shared/utility';

const initialState = {
    claim: null,
    // claimQuestions: null,
    loading: false,
    showConfirmationDialog: false,
    submittingClaim: false,
    claimsSubmitResponse: null,
    error: null,
    questionResponses: []
};

let hiddenQuestions = [];

const onClaimsQuestionFetchSuccess = (state, action) => {
    return updateObject(state, {
        finished: false,
        stepperLength: action.claimsQuestions.length,
        // claimQuestions: action.claimsQuestions,
        claim: action.claimData
    })
};

const onClaimsQuestionFailure = (state, action) => {

};

const onInputChange = (state, action) => {

    let isValidCategory = true;

    const claimsQuestion = updateObject(state.claim[action.stepIndex].claimQuestions[action.elementId], action.claimsQuestion);

    
    const claimQuestions = updateObject(state.claim[action.stepIndex].claimQuestions, {
        [action.elementId]: claimsQuestion
    });

    let claimQuestionsArray = [];
    for (let key in claimQuestions) {
        claimQuestionsArray.push(claimQuestions[key]);
    }
    claimQuestionsArray = CheckLinkedQuestions(claimsQuestion, claimQuestionsArray, action.questionsWithLinkedQuestions);

    claimQuestionsArray.forEach(question => {
        isValidCategory = question.isValid && isValidCategory;
    });

    const claimCategory = updateObject(state.claim[action.stepIndex], {
        claimQuestions: claimQuestionsArray,
        validCategory: isValidCategory
    });

    const categoryClaims = {
        [action.stepIndex]: claimCategory
    };

    const claimCategorys = updateObject(state.claim, categoryClaims);

    let claimCategoryaArray = [];
    for (let key in claimCategorys) {
        claimCategoryaArray.push(claimCategorys[key]);
    }

    let questionResponse = [...state.questionResponses];
    questionResponse[`q-${action.responseObject.questionId}`] = (action.responseObject);
    let questionResponses = updateObject(state.questionResponses, questionResponse);

    return updateObject(state, {
        claim: claimCategoryaArray,
        questionResponses: questionResponses
    });
};

const CheckLinkedQuestions = (selectedQuestion, questions, questionsWithLinkedQuestions) => {
    let filteredQuestions = [...questions];
    let linkedQuestion;
  
    for (let i = 0; i < questionsWithLinkedQuestions.length; i++) {
        if (selectedQuestion.questionId === questionsWithLinkedQuestions[i].questionId) {
            linkedQuestion = selectedQuestion;
            
            break;
        }
    }

    if (linkedQuestion) {
        let hasChildQuestion = linkedQuestion.linkedClaimRequestQuestions[0].childClaimsRequestQuestionId > 0;
        const currentQuestionTriggerResponse = linkedQuestion.linkedClaimRequestQuestions[0].claimRequestQuestionResponse;

        if (!hasChildQuestion) {
            if (linkedQuestion.value === currentQuestionTriggerResponse) {
                filteredQuestions = hideQuestionsLinkedtoAnsweredQuestion(linkedQuestion, filteredQuestions, questions);
            } else {
                filteredQuestions = showQuestionsLinkedToAnsweredQuestion(linkedQuestion, questions, filteredQuestions);
            }
        } else {
            let childQuestionId = linkedQuestion.linkedClaimRequestQuestions[0].childClaimsRequestQuestionId;
            const childQuestion = questions.find(question => question.questionId === childQuestionId.toString());
            const childQuestionResponse = linkedQuestion.linkedClaimRequestQuestions[0].childClaimRequestQuestionResponse;
            const currentQuestionTriggerResponse = linkedQuestion.linkedClaimRequestQuestions[0].claimRequestQuestionResponse;

            if (linkedQuestion.value === currentQuestionTriggerResponse && childQuestion.value === childQuestionResponse) {
                filteredQuestions = hideQuestionsLinkedtoAnsweredQuestion(linkedQuestion, filteredQuestions, questions);
            }
            else {
                filteredQuestions = showQuestionsLinkedToAnsweredQuestion(linkedQuestion, questions, filteredQuestions);
            }
        }
    }
   
    return filteredQuestions;
};


const onValidityCheck = (state, action) => {

    let isValidCategory = true;

    let claimQuestionsArray = [];
    for (let key in action.claimQuestions) {
        claimQuestionsArray.push(action.claimQuestions[key]);
    }

    claimQuestionsArray.forEach(question => {
        isValidCategory = question.isValid && isValidCategory;
    });

    const claimCategory = updateObject(state.claim[action.stepIndex], {
        claimQuestions: claimQuestionsArray,
        validCategory: isValidCategory
    });

    const categoryClaims = {
        [action.stepIndex]: claimCategory
    };

    const claimCategories = updateObject(state.claim, categoryClaims);

    let claimCategoriesArray = [];
    for (let key in claimCategories) {
        claimCategoriesArray.push(claimCategories[key]);
    }

    return updateObject(state, {
        claim: claimCategoriesArray
    });
};

const onProcessClaim = (state) => {
    return updateObject(state, {
        submittingClaim: true
    })
};

const onClaimsSubmitSuccess = (state, action) => {
    return updateObject(state, {
        submittingClaim: false,
        claimsSubmitResponse: action.data
    })
};

const onClaimsSubmitFailure = (state, action) => {
    return updateObject(state, {
        submittingClaim: false,
        error: action.error
    })
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.FETCH_CLAIMS_QUESTION_SUCCESS:
            return onClaimsQuestionFetchSuccess(state, action);
        case actionType.FETCH_CLAIMS_QUESTION_FAILURE:
            return onClaimsQuestionFailure(state, action);
        case actionType.INPUT_CHANGE:
            return onInputChange(state, action);
        case actionType.PROCESSING_CLAIM:
            return onProcessClaim(state, action);
        case actionType.SEND_CLAIMS_DATA_SUCCESS:
            return onClaimsSubmitSuccess(state, action);
        case actionType.SEND_CLAIMS_DATA_FAILURE:
            return onClaimsSubmitFailure(state, action);
        case actionType.VALID_CATEGORY_CHECK:
            return onValidityCheck(state, action);
        default:
            return state;
    }
};

export default reducer

const checkAnsweredQuestionForHiddenQuestions = (answeredQuestion) => {
    let hashidden = true;
    for (let index = 0; index < answeredQuestion.linkedClaimRequestQuestions.length; index++) {
        const linkedQuestion = answeredQuestion.linkedClaimRequestQuestions[index];
        const containsQuestionThatsHidden = hiddenQuestions.findIndex(hq => hq.questionId === linkedQuestion.claimRequestQuestionToNotDisplayId.toString()) !== -1;
        hashidden = containsQuestionThatsHidden && hashidden;
    }

    return hashidden;
}
const hideQuestionsLinkedtoAnsweredQuestion = (answeredQuestion, filteredQuestions, questions) => {
    let questionsToHide = [];
    answeredQuestion.linkedClaimRequestQuestions.forEach(linkedQuestion => {
        questionsToHide.push(linkedQuestion.claimRequestQuestionToNotDisplayId.toString());
    });
    filteredQuestions = questions.filter((question) => {
        if (!questionsToHide.includes(question.questionId)) {
            return question;
        }
        if (hiddenQuestions.length === 0) {
            hiddenQuestions.push(question);
        } else {
            let index = hiddenQuestions.findIndex(hq => hq.questionId === question.questionId);
            if (index === -1) {
                hiddenQuestions.push(question);
            }
        }
        return false;
    });
    return filteredQuestions;
}

const showQuestionsLinkedToAnsweredQuestion = (answeredQuestion, questions, filteredQuestions) => {
    const answeredQuestionHasHiddenQuestions = checkAnsweredQuestionForHiddenQuestions(answeredQuestion);
    if (answeredQuestionHasHiddenQuestions) {
        let hiddenQuestionForCategory = hiddenQuestions.filter(hiddenQuestion => hiddenQuestion.questionCategoryId === answeredQuestion.questionCategoryId)
        hiddenQuestionForCategory.forEach(hiddenQuestion => {
            let index = questions.findIndex(ques => ques.questionId === hiddenQuestion.questionId)
            if (index === -1)
                questions.push(hiddenQuestion);
        });
        questions.sort((a, b) => {
            return a.questionOrder - b.questionOrder;
        })
        hiddenQuestions = [];
        filteredQuestions = [...questions];
    }
    return filteredQuestions;
}




// WEBPACK FOOTER //
// ./src/store/reducers/claimsQuestionReducer.js